import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import {EntityMenuItem} from "../../reducers/messagingSlice";
import HypothesisChildModGroup from "./HypothesisItemChildModGroup";

interface ICartItemModGroups {
    hypothesisCartItemModGroups: EntityMenuItem[];
    // HITL-1757: a count prints as `4x sugar` on one line (flag on).
    showsCounts?: boolean;
    // HITL-1757: the item has a count somewhere, so every line keeps the gutter.
    hasCountGutter?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
    cartItemModGroupClass: {
        paddingLeft: theme.spacing(1.75),
    }
}));

export default function HypothesisCartItemModGroups({hypothesisCartItemModGroups, showsCounts = false, hasCountGutter = false}: ICartItemModGroups) {
    const { cartItemModGroupClass} =
        useStyles();
    return (
        <div className={`cartitem-mod-group ${cartItemModGroupClass}`}>
            {hypothesisCartItemModGroups.map((modifier) => (
                <HypothesisChildModGroup hypothesisCartItemModifier={modifier} key={modifier.id} showsCounts={showsCounts} hasCountGutter={hasCountGutter}/>
            ))}
        </div>
    );
}
